import React from 'react';
import { X, Reply } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { UserAvatar } from '@/components/UserAvatar';

interface ReplyPreviewProps {
  originalMessage: {
    id: string;
    content: string;
    sender_id: string;
    media_type?: string;
    media_url?: string;
  };
  senderName: string;
  onClear: () => void;
}

export default function ReplyPreview({ originalMessage, senderName, onClear }: ReplyPreviewProps) {
  const getPreviewContent = () => {
    if (originalMessage.media_type) {
      switch (originalMessage.media_type) {
        case 'image':
          return '📷 Image';
        case 'video':
          return '🎥 Video';
        case 'gif':
          return '🎬 GIF';
        default:
          return '📎 Media';
      }
    }
    
    // Truncate long text messages
    const text = originalMessage.content || '';
    return text.length > 50 ? text.substring(0, 50) + '...' : text;
  };

  return (
    <div className="mx-4 mb-2 p-3 bg-muted/30 border border-border rounded-t-xl">
      <div className="flex items-start gap-3">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <Reply className="h-4 w-4 text-muted-foreground flex-shrink-0" />
          <UserAvatar
            userId={originalMessage.sender_id}
            size="sm"
            className="flex-shrink-0"
          />
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-xs font-medium text-muted-foreground">
                Replying to {senderName}
              </span>
            </div>
            <div className="text-sm text-foreground/80 truncate">
              {getPreviewContent()}
            </div>
          </div>
        </div>
        
        <Button
          size="sm"
          variant="ghost"
          onClick={onClear}
          className="h-6 w-6 p-0 rounded-full hover:bg-muted flex-shrink-0"
        >
          <X className="h-3 w-3" />
        </Button>
      </div>
    </div>
  );
}